import { render } from "./test_item.vue?vue&type=template&id=5f61f36c&scoped=true"
import script from "./test_item.vue?vue&type=script&lang=js"
export * from "./test_item.vue?vue&type=script&lang=js"

import "./test_item.vue?vue&type=style&index=0&id=5f61f36c&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f61f36c"]])

export default __exports__